<template>
  <ion-content scroll-y="false">
    <ion-item @click="getProfile">
      <ion-ripple-effect type="unbounded"></ion-ripple-effect>
      Profile For Chat Partner
    </ion-item>
    <ion-item @click="blockUser">
      <ion-ripple-effect type="unbounded"></ion-ripple-effect>
      Block User
    </ion-item>
    <ion-item @click="reportAndBlock">
      <ion-ripple-effect type="unbounded"></ion-ripple-effect>
      Report and Block User
    </ion-item>
  </ion-content>
</template>

<script>
import { IonContent, IonRippleEffect, IonItem } from "@ionic/vue";
import { defineComponent } from "vue";
import { bus } from "../../main";

export default defineComponent({
  name: "Popover",
  components: { IonContent, IonRippleEffect, IonItem },
  methods: {
    getProfile() {
      bus.emit("chatPopoverGetProfile");
    },
    blockUser() {
      bus.emit("chatPopoverBlockUser");
    },
    reportAndBlock() {
      bus.emit("chatPopoverReportAndBlock");
    },
  },
});
</script>